import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import de from './locales/de.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export function changeAppLanguage(language) {
  const lng = language === 'de' ? 'de' : 'en';
  return i18n.changeLanguage(lng);
}

export default i18n;
